"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalNumber = void 0;
var useConfigContext_1 = require("../useConfigContext/useConfigContext");
exports.useLocalNumber = function (config) {
    var languageCode = useConfigContext_1.useConfigContext().languageCode;
    var value = config.value, type = config.type, currency = config.currency;
    var style = currency ? 'currency' : type;
    var maxDigits = type === 'percent' ? 17 : undefined;
    return new Intl.NumberFormat(languageCode, { style: style, currency: currency, maximumFractionDigits: maxDigits }).format(value);
};
